import { theme } from "@tm/utility/global";
import styled, { css, keyframes } from "styled-components";

const shimmerAnimation = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const shimmerBg = css`
  background: linear-gradient(
    69deg,
    ${theme.whiteText2} 19.37%,
    #f9f9f9 37.56%,
    ${theme.darkGreyBg} 56.06%
  );
  background-size: 200% 100%;
  animation: ${shimmerAnimation} 1.5s linear infinite;
`;

export const ShimmerLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ShimmerSection = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  padding: 24px;
`;

export const ShimmerHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ShimmerLogo = styled.div`
  width: 51px;
  height: 50px;
  border-radius: 10px;
  flex-shrink: 0;
  ${shimmerBg}
`;

export const ShimmerTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  height: 57px;
  width: 315px;
`;

export const ShimmerBar = styled.div<{
  $width: string;
  $height: string;
  $radius?: string;
}>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  border-radius: ${({ $radius }) => $radius || "8px"};
  flex-shrink: 0;
  ${shimmerBg}
`;

export const ShimmerCardsRow = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
`;

export const ShimmerCard = styled.div`
  flex: 1 0 0;
  min-width: 0;
  height: 309px;
  border-radius: 16px;
  overflow: hidden;
  padding: 8px 8px 16px;
  ${shimmerBg}
`;

export const ShimmerContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const WhyBookShimmerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 16px;
`;

export const WhyBookShimmerItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const FaqShimmerBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const FaqShimmerItem = styled.div`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${theme.disabledGrey2};
`;
